import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { posterUrl, getMediaType, getTitle } from "../services/tmdb";

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  show: { y: 0, opacity: 1, transition: { type: "spring", stiffness: 100 } }
};

function Poster({ item }) {
  const navigate = useNavigate();
  const title = getTitle(item);
  const type = item.mediaType || getMediaType(item);
  const image = posterUrl(item.poster_path);

  const handleClick = () => {
    navigate(`/details/${type}/${item.id}`);
  };

  return (
    <motion.div
      variants={itemVariants}
      whileHover={{ scale: 1.05, y: -5 }}
      whileTap={{ scale: 0.95 }}
      className="poster-wrapper col-lg-2 col-md-3 col-sm-4 col-6 mt-2 mb-3"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <div className="poster-card">
        {image ? (
          <>
            <img
              className="poster-img"
              src={image}
              alt={title}
            />
            <div className="poster-overlay">
              <div className="poster-overlay-content">
                <span className="poster-title">{title}</span>
                {item.vote_average > 0 && (
                  <span className="poster-rating">⭐ {item.vote_average.toFixed(1)}</span>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="skeleton-loader d-flex align-items-center justify-content-center text-center p-2">
            <span style={{ color: "var(--text-secondary)", fontSize: "0.9rem", fontWeight: "bold" }}>{title}</span>
          </div>
        )}
      </div>
    </motion.div>
  );
}

export default Poster;
